// Phase A.2.b · Phone selection + tel: sanitization for Contact rows.
//
// Field priority (matches Contact schema — do not rename):
//   1. contact.mobile
//   2. contact.office_phone
//   3. contact.alternate_phone
// Returns null if none set (icon should NOT render).
//
// `telHref` strips spaces/dashes/parens/letters and preserves a leading
// `+` if present. Purely defensive — inputs come from user-entered fields.

export function bestPhone(contact) {
  if (!contact) return null;
  const candidates = [contact.mobile, contact.office_phone, contact.alternate_phone];
  for (const raw of candidates) {
    if (raw && String(raw).trim()) return String(raw).trim();
  }
  return null;
}

export function telHref(phone) {
  if (!phone) return null;
  const trimmed = String(phone).trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return null;
  return `tel:${hasPlus ? "+" : ""}${digits}`;
}
